import { Checkbox } from "antd";

const TriStateCheckbox = ({ value, onChange, children }) => {
  const getChecked = () => value === true;
  const getIndeterminate = () => value === null;

  const handleClick = () => {
    let newValue;
    if (value === null) newValue = true;        // null → true
    else if (value === true) newValue = false;  // true → false
    else newValue = null;                       // false → null
    onChange(newValue);
  };

  return (
    <div>
      <Checkbox checked={getChecked()} indeterminate={getIndeterminate()} onClick={handleClick} style={{marginTop:"2px"}}>
          {children}
      </Checkbox>
    </div>
  );
};

export default TriStateCheckbox;